/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-no-bind */

// material
import { styled } from '@mui/material/styles'
import { Card, Typography } from '@mui/material'
import { MHidden } from '../../components/@material-extend'

// ----------------------------------------------------------------------

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}))

// ----------------------------------------------------------------------

export default function ClientMenuLeft() {
  return (
    <MHidden width="mdDown">
      <SectionStyle>
        <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}></Typography>
        <img
          alt="register"
          src="/static/illustrations/COMTEL_PLAINTES_IMAGE.png"
        />
        <img alt="register" src="/static/illustrations/home2.jpg" />
      </SectionStyle>
    </MHidden>
  )
}
